import React from "react";

import { LoadingOverlay } from "../../../../components/LoadingOverlay/LoadingOverlay";
import RequestsTable from "../../../../components/RequestsTable/RequestsTable";
import type { IOrganization } from "../../../../contexts/organizations/organizationsContext";
import { useCacheItemRequests } from "../../../../hooks/reactQueryHooks/useCacheItems";
import { useQueryParams } from "../../../../hooks/useQueryParams";

export interface RequestsTabProps {
  projId: string;
  cacheId: string;
  currentOrganization: IOrganization | null;
}

const RequestsTab: React.FC<RequestsTabProps> = ({
  projId,
  cacheId,
  currentOrganization,
}) => {
  const { queryValue: pageIndex } = useQueryParams({
    queryStr: "p",
  });

  const { data, isLoading, isFetching } = useCacheItemRequests(
    cacheId,
    currentOrganization?.id || "",
    projId,
    pageIndex ? Number(pageIndex) : 1,
  );

  return (
    <>
      {(isFetching || isLoading) && <LoadingOverlay />}
      <RequestsTable
        items={data?.items || []}
        totalItems={data?.totalCount || 0}
        isLoading={isLoading || isFetching}
        currentOrganization={currentOrganization || undefined}
        isSingleCacheItem={true}
        pageSize={data?.pageSize || 0}
      />
    </>
  );
};

export { RequestsTab };
